const norm = (s) =>
  (s || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const matchesQuery = (item, query) => {
  const q = norm(query).trim();
  if (!q) return true;
  const hay = norm(
    [item.title, item.description, item.excerpt, item.category, item.body, item.doc_name].join(" ")
  );
  return q.split(/\s+/).every((w) => hay.includes(w));
};
